export const environment = {
    production: true,
    //apiLoginUrl: 'http://localhost:52926/api/',
    //apiUrl: 'http://localhost:52926/api/',
    //headerHost: 'http://localhost:52926',
    //apiUrlMsinExportsAPI: 'https://localhost:44337/api',
    //apiUrlMSINCatalogAPI: 'https://localhost:7046/api/',

    apiLoginUrl: 'https://fde-msindev-dse0cee6enc4g2cy.a03.azurefd.net/api/',
    apiUrl: 'https://fde-msindev-dse0cee6enc4g2cy.a03.azurefd.net/api/',
    headerHost: 'https://fde-msindev-dse0cee6enc4g2cy.a03.azurefd.net',
    apiUrlMsinExportsAPI: 'https://fde-msindev-dse0cee6enc4g2cy.a03.azurefd.net/exportsapi/api',
    apiUrlMSINCatalogAPI: 'https://fde-msindev-dse0cee6enc4g2cy.a03.azurefd.net/catalogapi/api/',

    //'https://msincatalogapi.bluemoss-4308f2f5.westus2.azurecontainerapps.io/api/',
    //apiUrlMSINCatalogAPI: 'https://localhost:7046/api/',
    //google authenticators
    
    recaptchaSiteKey: '6LfkyJMdAAAAAAVFu0O4YarRCjMRYnPnwmsOWHCI',
    // timeout settings
    timeoutPingInterval: 15, // in seconds
    timeoutIdleTime: 300, // in seconds, default at 840
    timeoutKickoutTime: 60, // in seconds
    useSessionTracker: true,
    otherBrowserKickTime: 10000,
    sessionClearDelay: 500,
    // exports api settings
    exportDebugMode: false
    //All configuration setting will go here...
};
